import { Navigate, Route, Routes } from "react-router-dom";
import { CarriersView } from "./carriers/CarrierView";
import CarrierSignup from "./signup/carrier/CarrierSignup";
import VendorSignup from "./signup/vendor/VendorSignUp";
import ReceiverSignup from "./signup/receiver/ReceiverSignUpPage";
import React from "react";
import { useAuthService } from "./auth/AuthProvider";
import { PageNotFound } from "./components/PageNotFound";

interface PublicRoutesProps {}

export const PublicRoutes: React.FC<PublicRoutesProps> = ({}) => {
  const authService = useAuthService();

  if (authService.authState !== null) {
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="receiver-signup" />} />
      {/* LANDING / SHARED */}
      <Route path="/carriers" element={<CarriersView />} />
      <Route path="/carrier-signup" element={<CarrierSignup />} />
      <Route path="/shipper-signup" element={<VendorSignup />} />
      <Route path="/receiver-signup" element={<ReceiverSignup />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
